export default {
    dashboardTitle: 'Dashboard',
};
